<template>
  	<main class="body-wrapper" id="home-page">
      <navbar></navbar>
      <transition name="fade">        
        <router-view :user="user"/>
      </transition> 
      <my-footer></my-footer>   
  	</main>
</template>

<style>


element.style {
}
.btn:not(:disabled):not(.disabled) {
    cursor: pointer;
}

</style>

<script>

import Navbar from './components/Navbar.vue';
import MyFooter from './components/MyFooter.vue';
import Noty from './components/helpers/Noty.vue';
import {EventBus} from './event-bus.js';

export default {
  name: 'app',
    data () {
    return {
      user: { 
        admin: false 
      }      
    }
  },
  mounted () {

    var that = this;

    EventBus.$emit('app start');

    $.get('/api/user', function(res){
      that.user = res.data;      
    });

  },  
  components:{
      navbar: Navbar,
      myFooter: MyFooter,
      Noty: Noty
  },
  methods:{

  }

}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>



// WEBPACK FOOTER //
// src/js/App.vue